
var VENUEID = $('#venueId').val();

function getSharedRevenueList(callback) {
	 var userId = $("#userId").val();
    $.ajax({
        url: '/revenueshare/getshare?venueId=' + VENUEID, 
        method: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        error: function (err) {
          Swal.fire("Revenue Split Error", err.responseJSON.error, "error");
        },
        success: function (res) {
            if (res.result) {
                var shareHtml = "";
                var approvedHtml = "";
                for (var index = 0; index < res.result.length; index++) {
									
                    var inputBoxId = res.result[index].toUser.replace(/@/g, "").replace(/[.]/g, "");
										let deleteShareBtn = `<button class="fa fa-times text-danger btn btn-sm mr-2" aria-hidden="true" onclick="deleteShare('${res.result[index].toUserId}','${res.result[index]._id}')"></button>`;
										let updateBtn = `<button class="fa fa-check text-success btn btn-sm" title="Update" onclick="updateShares('${res.result[index].toUser}','${inputBoxId}','${res.result[index].revenueShared}','${index}',false,'${res.result[index]._id}')" ></button>`;
                    var textHtml = ' <div class="form-group row">' +                        
                        '<div class="col-xs-11 col-sm-10 col-md-10" style="padding-left: 0;">' +
                        '<div class="row">' +
                        '<div class="col-xs-2 col-sm-2 col-md-3"><input type="text" id="' + inputBoxId+index+ '" class="col-xs-12 form-control" style="min-width: 50px" value="'+res.result[index].revenueShared +'"/></div>' +
                        '<div class="col-xs-7 col-sm-7 col-md-6" style="word-wrap: break-word;">' + res.result[index].toUser  + ' (Requested)</div>' +
                        '<div class="col-xs-3 col-sm-3 col-md-3"><span class="btn" style="display:inline-block; margin-right:2px" data-toggle="tooltip" title="Clear">'+deleteShareBtn +
                        updateBtn +
                        '</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>';	
												
                    shareHtml = shareHtml + textHtml;
                }
								
                $('#shareData').html(shareHtml);
								
                if(callback){
                    callback("done");
                }
            }
        }
    });
}

function getPendingRevenues(VENUEID){
	var pendingRev = null;
	let totalRevenue = 35;
	let currentUserId = $("#userId").val();
	let isLead = $("#isLead").val();
	  $.ajax({
        url: '/revenueshare/getPendingRevenue?venueId='+VENUEID,
        method: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
				async : false,
        error: function (err) {
            callback("nope");
        },
        success: function (res) {
					  if (res.result && res.result.length) {
							var pendingTotal = 0;
							for (var index = 0; index < res.result.length; index++) {
								//if(res.result[index].toUserId == currentUserId){
									pendingTotal += parseInt(res.result[index].revenueShared);
								//}
							}
							pendingRev = parseInt(totalRevenue) - pendingTotal;
							pendingRev > 0 ? pendingRev : 0;
						}				
				}
	  });
		
	return pendingRev == null ? totalRevenue : pendingRev;
}

$(document).on('click',".sharePercent", function(){
	let btnText = $(this).closest(".shareForm").children("div").children(".btnShareRevenue").text();
	if(btnText == "Requested" || btnText == "Approved") {
		$(this).closest(".shareForm").children("div").children(".btnShareRevenue").text("Update Share");
	}
})
$(document).on('click',".btnShareRevenue", function(){
	let totalPendingRev = getPendingRevenues(VENUEID);
		var currentUserId = $("#userId").val();
		var isLead = $("#isLead").val();
//odd this is not gettig data after minifier    var revenueSharePersons = JSON.parse($("#revenueSharePersons").val());
    var revenueSharePersons = JSON.parse($("#revenueSharePersons").text());
    var element = this 
    var toUser = $(element).parents('.shareForm').find(".shareToUser").val();
    var toUserId = $(".shareToUserId").val();
    var revenuePercent = $(element).parents('.shareForm').find(".sharePercent").val();
		if(toUser){
					if(parseInt(revenuePercent) <= parseInt(totalPendingRev)){
			$.ajax({
					url: '/revenueshare/share',
					method: 'POST',
					contentType: "application/json; charset=utf-8",
					data: JSON.stringify({
							fromUserId : currentUserId,
							toUserId: toUserId,
							toUser: toUser,
							revenueShared: revenuePercent,
							venueId: VENUEID,
							leadSalespersonId : revenueSharePersons[0].user.userId,
					}),
					dataType: 'json',
					error: function (err) {
						Swal.fire("Revenue Split Error", err.responseJSON.error, "error");
						$(element).parents('.shareForm').find(".sharePercent").val("");
        },
					success: function (res) {
							$(this).text('Requested');
							if (res.ok) {
									$(element).parents('.shareForm').find(".sharePercent").val("");
									if(isLead == true){
										$(element).parents('.shareForm').find(".shareToUser").val("");
									} else {
										$(element).parents('.shareForm').find(".shareToUser").val(toUser)
									}
									
									$("#addshare").text('Submit');
									getSharedRevenueList(function (val) {
										Swal.fire("Split Revenue Shares!", "Request Sent Successfully", "success");
											
									});
							} else {
									//Swal.fire("Split Share!", "Revenue shared successfully but data is not refreshed on page", "success");
							}
					}
				});
			} else {
				Swal.fire("Split Share!", "Revenue percent is insufficient to share!", "error");
			}    
		} else {
			Swal.fire("Revenue Split Error", "Please Enter Salesperson's email", "error");
		}
});

function loadOtherUsersShare(callback) {
	let currentUserId = $("#userId").val();
    $.ajax({
        url: '/revenueshare/sharedwithme?venueId=' + VENUEID + '&userId='+currentUserId,
        method: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        error: function (err) {
            callback("nope");
        },
        success: function (res) {
            if (res.ok) {
                //something here
                if (res.result && res.result.length) {
           		$('.sharedbyOtherContainer').removeClass('hide');
				 let action = ``;
				 let revApproved = ``;
				 let type = "";
					res.result.forEach((item, index) =>{
					// if(item.approvedToUser == false && item.fromUserId == currentUserId){
						// $('.sharedbyOtherContainer').addClass('hide');
					// }
					var cleanEmail = item.fromUser.replace(/@/g, "").replace(/[.]/g, "");
					
					revApproved = `<input type="text" class="col-6 form-control" style="min-width: 50px" title="Percentage" name="approvePer" value="${item.revenueShared}" id="approvePer${cleanEmail}${index}" placeholder="% to approve" ${ item.approvedToUser == true ? 'disabled' : '' }/>`;
					if(item.approvedToUser == true){
						action = `<button type="button" style="width: 90px; font-size:13px !important;" class="btn btn-sm form-control" disabled>Approved</button>`;
						type = "Approved";
					} else {
							action = `<button type="button" style="width: 90px; font-size:13px !important;" onclick="approveShare('${item.fromUser}','${item.revenueShared}','${cleanEmail}','${index}','${item._id}')" class="btn btn-sm form-control ${item.fromUserId == currentUserId ? 'disabled' : ''}">Approve</button>`;
							type = "Request";
					}

					if(item.revenueShared.indexOf('%') !== -1){
						item.revenueShared =  item.revenueShared + "";
					}else{
						item.revenueShared =  item.revenueShared + " %";
					}
					
					item.revApproved = revApproved;
					item.action = action;
					item.type = type;
					item.userName = item.fromUserInfo.firstName +" "+item.fromUserInfo.lastName;
					return item;
					});
					
				 	if($.fn.DataTable.isDataTable("#sharedbyOther")){
						$("#sharedbyOther").dataTable().fnDestroy();
					}
					$("#sharedbyOther").DataTable({
						data: res.result,
						columns: [
								{data: 'userName', title: 'From User'},
								{data: 'fromUser', title: 'From User Email'},
								{data: 'toUser', title: 'To User Email'},
								{data: 'type', title: 'Type'},
								{data: 'revenueShared', title: 'Revenue Shared'},
								{data: 'revApproved', title: 'Revenue Approved'},
								{data: 'action', title: 'Action'},
						],
						order: [[ 1, "ASC" ]],
						ordering: true,
						responsive: true,
						paging: false,
						searching: false,
						info: false,
						autoWidth: false
					});
									
                } else {
									
                }
            } else {
                callback("not_done");
            }
            callback("done");
        }
    });
}

loadOtherUsersShare(function (resD) {
    //nothing here
});

function updateShares(toUser, boxId, revenueShared,index,updateType=false,_id) {
		let totalPendingRev = getPendingRevenues(VENUEID);
    var vnId = $('#venueId').val();
    var updatedRevenue = $('#' + boxId+index).val();
		if(parseInt(updatedRevenue) <= parseInt(totalPendingRev)){
			if (!isNaN(parseInt(updatedRevenue))) {
					$.ajax({
							url: '/revenueshare/reshare',
							method: 'POST',
							contentType: "application/json; charset=utf-8",
							data: JSON.stringify({
									_id: _id,
									toUser: toUser,
									updatedRevenue: updatedRevenue,
									venueId: vnId,
									updateType: updateType,
							}),
							dataType: 'json',
							error: function (err) {
								Swal.fire("Revenue Split Error", err.responseJSON.error, "error");
							},
							success: function (res) {
									if (res.ok) {
											//loadOtherUsersShare(function (lit) {
												Swal.fire("Split Share!", "Updated", "success");
											//})
									} else {
										Swal.fire("Split Share!", "Problem with updating revenue share split", "error");
									}
							}
					});
			} else {
				Swal.fire("Split Share!", "Please Enter a Number", "error");
			}
		} else {
			Swal.fire("Split Share!", "Revenue percent is insufficient to share!", "error");
		}
}

function approveShare(fromUser, revenueShared,cleanEmail,index,_id) {
		let totalPendingRev = getPendingRevenues(VENUEID);
    var vnId = $('#venueId').val();
    var inputId = "#approvePer"+cleanEmail+index;
    var revenueApproved = $(inputId).val();
		if(parseInt(revenueApproved) <= parseInt(totalPendingRev)){
			if (!isNaN(parseInt(revenueApproved))) {
        $.ajax({
            url: '/revenueshare/sharedwithme/update',
            method: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
							  _id: _id,
                fromUser: fromUser,
                revenueApproved: revenueApproved,
                venueId: vnId
            }),
            dataType: 'json',
						error: function (err) {
							Swal.fire("Revenue Split Error", err.responseJSON.error, "error");
						},
            success: function (res) {
                if (res.ok) {
										let pendingRev = getPendingRevenues(VENUEID);
										$("#totalRevenue").html(pendingRev);
                    loadOtherUsersShare(function (lit) {
                        Swal.fire("Split Share!", "Revenue Share Approved Successfully", "success");
                    })
                } else {
                    Swal.fire("Split Share!", "Problem with updating revenue share split", "error");
                }
            }
					});
			} else {
				Swal.fire("Split Share!", "Please Enter a Number", "error");
			}
		} else {
			Swal.fire("Split Share!", "Revenue percent is insufficient to share!", "error");
		}
}

function deleteShare(inputBoxId,_id) {
	let toUserId = $("#userId").val();
    $.ajax({
        url: '/revenueshare/deleteshare',
        method: 'POST',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({
						_id:_id,
            toUserId: toUserId,
            venueId: VENUEID
        }),
        dataType: 'json',
        success: function (res) {
					if (res.ok) {
							getSharedRevenueList(function (val) {
								Swal.fire("Split Share!", "Revenue share removed", "success");
							})
					} else {
						Swal.fire("Split Share!", "Revenue shared successfully removed but data is not refreshed on page", "success");
					}
        }
    });
}


$('#headingSplitRevenue').click(function(){
 console.log("click on revenue share");
	getSharedRevenueList();
	let pendingRev = getPendingRevenues(VENUEID);
	$("#totalRevenue").html(pendingRev);
})
